import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Input } from "@cofano/cck";
import { Grid } from "@mui/material";
import { Language } from "imports/Utils";

export default ({ control }) => {
	return (
		<Grid xs={6} item>
			<h3>{Language("LETTER_OF_PROTEST_ISSUED_BY")}</h3>

			<FormGroup label={Language("LETTER_OF_PROTEST_NAME")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.footerIssuedByName"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_SIGNATURE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.footerIssuedBySignature"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_POSITION")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.footerIssuedByPosition"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_PLACE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.footerIssuedByPlace"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_DATE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.footerIssuedByDate"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>
		</Grid>
	);
};

